import { ComponentRef, ViewContainerRef } from '@angular/core';
import { RegisterPassKeyPromptComponent } from './register-pass-key-prompt.component';

class RegisterPassKeyPromptSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  viewContainerRef: ViewContainerRef;
  registerPassKeyPromptComponent: ComponentRef<RegisterPassKeyPromptComponent>;

  constructor(formId: string, payload: object) {

      this.formId = formId;
      this.payload = payload;
  }

  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }
  endSession(): void {

  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    this.viewContainerRef.clear();
    this.registerPassKeyPromptComponent = this.viewContainerRef.createComponent(RegisterPassKeyPromptComponent);

    this.registerPassKeyPromptComponent.instance.onCreatePasskeySubmit = this.onSubmitPasskey.bind(this);
    this.registerPassKeyPromptComponent.instance.onPasskeySkipSubmit = this.onSkipPasskey.bind(this);
    this.registerPassKeyPromptComponent.instance.onPasskeyDeclineSubmit = this.onDeclinePasskey.bind(this);

    // const journeyPayload = this.payload as JourneyPayload;
    // const action = journeyPayload.actions[0] as ActionsInPayload;

    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

          this.submitBlock = null; // prevent reuse of a settled promise
        } catch (e) {

          console.error(e);
        }
      };
    });
  }
  onContinue(payload: object): void {

  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  /** Non UIFormSession interface Functions */
  private onSubmitPasskey() {
    this.submitBlock({result: 'enable'});
  }

  private onSkipPasskey() {
    this.submitBlock({result: 'skip'});
  }

  private onDeclinePasskey() {
    this.submitBlock({result: 'decline'});
  }

}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default RegisterPassKeyPromptSession;
